export default {
  apiTrafficManager: 'https://talmudfinder-2-1c.loadbalancer.dicta.org.il/TalmudFinder',
}
